import { render } from "./ModuPlan.vue?vue&type=template&id=435ff122"
import script from "./ModuPlan.vue?vue&type=script&lang=js"
export * from "./ModuPlan.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Software\\Aplicaciones\\allikamay\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__